import { useState } from 'react';

export default function Hero() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const backgroundImageStyle = {
        backgroundImage: `linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1)), url(${require('./BasementFlooding.jpeg')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    };

    return (
        <section id="hero"
            className="relative"
            style={backgroundImageStyle}
        >
            <div
                className="absolute inset-0 bg-white/75 sm:bg-transparent sm:from-white/95 sm:to-white/25 ltr:sm:bg-gradient-to-r rtl:sm:bg-gradient-to-l"
            ></div>

            <div
                className="relative mx-auto max-w-screen-xl px-4 py-32 sm:px-6 lg:flex lg:h-screen lg:items-center lg:px-8"
            >
                <div className="max-w-xl text-center ltr:sm:text-left rtl:sm:text-right font-title">
                    <h1 className="text-4xl font-extrabold sm:text-5xl text-night">
                        Concrete Repair &<br />
                        <strong className="block text-navy-blue">
                            Wet Basement Solutions
                        </strong>
                    </h1>

                    <p className="mt-4 text-lg leading-7 sm:text-xl sm:mt-5 sm:max-w-2xl mx-auto font-sans">
                        Your Trusted Experts for Wet Basement Repairs in Kitchener, Waterloo, Cambridge, Guelph, and Beyond. We specialize in crack injection and waterproofing solutions, fixing wet basements and foundation issues.
                    </p>

                    <div className="mt-8 flex flex-wrap justify-center gap-4 text-center">
                        <a
                            href="#contact"
                            className="block w-full rounded bg-rose-600 px-6 py-3 text-md font-medium text-white shadow hover:bg-rose-700 focus:outline-none sm:w-auto"
                        >
                            Request a Quote
                        </a>

                        <a
                            href="#about"
                            className="block w-full rounded bg-white px-6 py-3 text-md font-medium text-rose-600 shadow hover:text-rose-700 focus:outline-none  sm:w-auto"
                        >
                            Learn More
                        </a>
                    </div>
                </div>
            </div>

        </section >
    );
}
